/// <reference path="../typings.d.ts" />
import { OnInit, Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppTitle } from './title';
import { OneRosterService } from './oneroster.service';
import { Alert } from './alert';
import { SftpRegistration } from './sftp_registration';
import { FindAccountAssociation } from './account_association_find';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { isDateSet, dateFormat, rfc3339ToDate } from './date_helper';

@Component({
	selector: 'sftp-sync',
	styles: [`
        .mt2 {
            margin-top: 15px;
        }
    `],
	template: `
        <div class="col-lg-6 col-md-8 col-xs-12">
            <p style='color: #919191;'>SFTP Sync Settings</p>
            <div class="customHr" style="width:150px">.</div>
            <form [formGroup]="form" novalid>
                <div class="row">
                    <div class="col-md-6 col-xs-12" style="margin-bottom: 0px;padding-left:0px!important;">
                        <div class="form-group">
                            <p class="custom-label">Sync Cron Job</p>
                            <input style="margin-bottom: 5px;" type="text" formControlName="syncCronJob" class="form-control" placeholder="Sync Cron Job" title="Sync Cron Job">
                            <a href="https://crontab.guru" target="_blank">Generate Here</a>
                        </div>
                    </div>
                </div>
            </form>

            <p style='color: #919191; margin-top: 20px'>Sync Status</p>
            <div class="customHr" style="width:140px">.</div>

            <p>Number of Students: {{data.studentCount}}</p>
            <p>Number of Students Contacts: {{data.studentContactCount}}</p>
            <p>Number of Organizations: {{data.organizationCount}}</p>
            <p>Last Sync At: {{printDate(data.lastSyncedAt)}}</p>
            <p>Sync Error: {{data.lastSyncError != "" ? data.lastSyncError : 'No errors'}}</p>
            <p>Last Sync Error At: {{printDate(data.lastSyncErrorAt)}}</p>
            <p>Sync Status: {{syncStatusTitle}}</p>

            <div class="row mt2">
                <button [disabled]="!showSaveButton" type="button" class="btn btn-large btn-primary" (click)="save()">{{ saveTitle }}</button>
                <a type="button" class="btn btn-large btn-deny" style="margin-left:10px; cursor: pointer;" (click)="refresh()">Refresh</a>
                <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
            </div>

            <div class="row mt2" [hidden]="msg.msg == ''">
                <alert [alert]="msg"></alert>
            </div>
        </div>
    `
})

export class SftpSyncComponent implements OnInit {
	msg: Alert;
	msgHead: Alert;
	acctNumber: string;
	hasAccess: boolean;
	idParam: string;
	form: FormGroup;
	data: SftpRegistration;
	saveCount: number;
	saveTitle: string;
	syncStatusTitle: string;
	syncStatus: string;
	showSaveButton: boolean;

	constructor(private router: Router, private orvc: OneRosterService, private title: AppTitle, private activatedRoute: ActivatedRoute, fb: FormBuilder) {
		this.hasAccess = true;
		this.msg = new Alert();
		this.msgHead = new Alert();
		title.setTitles({
			title: 'SFTP Sync',
			dashboard: 'SFTP Sync'
		});

		this.form = fb.group({
			syncCronJob: ['', Validators.compose([Validators.required])],
		});
		this.saveCount = 1;

		this.data = new SftpRegistration();
		this.saveTitle = '';
		this.syncStatusTitle = '';
		this.syncStatus = '';
		this.showSaveButton = false;
	}

	ngOnInit() {
		this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
		this.idParam = this.activatedRoute.snapshot.params['id'];

		this.title.setBreadcrumbs([
			{ title: 'SFTP ', link: `/settings/${this.acctNumber}/sftp` },
			{ title: this.idParam + ' ', link: `` },
			{ title: 'Sync', link: `` }
		]);

		this.loadData();
	}

	checkForAccountAssociation() {
		let findc = new FindAccountAssociation();
		findc.registrationId = parseInt(this.idParam);
		this.orvc.accountAssociationFindCountApi(this.acctNumber, findc)
			.subscribe((row) => {
				if (row.count == 0) {
					setTimeout(() => {
						this.msg.warningHtml("School Mapping not completed for this registration!")
					}, 500);
				}
			}, err => {
				console.log(err);
				this.msg.error(this.orvc.getUserErrorDefault(err));
			});
	}

	loadData() {
		this.orvc.sftpRegistrationFindApi(this.acctNumber, { id: parseInt(this.idParam) })
			.subscribe((rows: SftpRegistration[]) => {
				this.msg.close();
				this.data = rows[0];
				this.data.lastSyncedAt = rfc3339ToDate(this.data.lastSyncedAt);
				this.data.lastSyncErrorAt = rfc3339ToDate(this.data.lastSyncErrorAt);
				this.form.get('syncCronJob').setValue(this.data.syncCrunJob);

				this.saveTitle = this.statusSaveTitle(this.data.syncStatus);
				this.showSaveButton = false;
				if (this.data.syncStatus !== 'disabled') {
					this.showSaveButton = true;
				}
				this.syncStatus = this.data.syncStatus;
				this.syncStatusTitle = this.data.syncStatus;

				this.checkForAccountAssociation();
				
				if (this.syncStatus === 'initializing') {
					setTimeout(() => {
						this.loadData();
					}, 3000);
                }
			}, err => {
				console.log(err);
				this.msg.error(this.orvc.getUserErrorDefault(err));
			});
	}

	save() {
		if (!this.form.valid) {
			return;
		}

		let regSyncRequest = {
			status: this.syncStatus,
			syncCrunJob: this.form.get('syncCronJob').value
		};

		if (this.data && this.data.organizationCount === 0 && this.syncStatus !== 'initializing' && this.syncStatus !== 'stopping') {
			regSyncRequest.status = 'initializing';
		} else {
			switch (regSyncRequest.status) {
				case 'initialized':
				case 'error':
				case 'stopped':
					regSyncRequest.status = 'starting';
					break;
				case 'started':
					regSyncRequest.status = 'stopping';
					break;
				case 'starting':
				case 'initializing':
				case 'stopping':
					regSyncRequest.status = 'stopping';
					break;
				case '':
				case 'error-initializing':
					regSyncRequest.status = 'initializing';
					break;
				default:
					regSyncRequest.status = 'starting';
					break;
			}
		}

		this.orvc.sftpRegistrationSyncApi(this.acctNumber, this.data.id, regSyncRequest)
			.subscribe(res => {
				let saveMessage = this.orvc.getDefaultSaveMessage();
				if (this.saveCount > 1) {
					saveMessage += ` (${this.saveCount})`
				}
				this.saveCount++;
				this.msg.success(saveMessage);
				setTimeout(() => {
					this.loadData();
				}, 1000);
			}, err => {
				console.log(err);
				this.msg.error(this.orvc.getUserErrorDefault(err));
			});
	}

	statusSaveTitle(st: string): string {
		if (this.data && this.data.organizationCount === 0) {
			if (st === 'initializing') {
				return 'Stop Initialization';
			}
			return 'Start Initialization';
		}

		switch (st) {
			case '':
			case 'error-initializing':
				return 'Start Initialization';
			case 'initializing':
				return 'Stop Initialization';
			case 'stopped':
			case 'initialized':
			case 'error':
				return 'Start Syncing';
			case 'starting':
			case 'stopping':
			case 'started':
				return 'Stop Syncing';
			case 'disabled':
				return 'Disabled';
		}
		return '';
	}

	refresh() {
		this.loadData();
	}

	goBack() {
		this.router.navigate([`/settings/${this.acctNumber}/sftp`]);
	}

	printDate(d: Date): string {
		let df = '01/02/2006 03:04 PM';
		if (isDateSet(d)) {
			return dateFormat(d, df);
		}
		return '';
	}
}
